var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-container"},[_c('video',{ref:"videoElement",attrs:{"playsinline":"","crossorigin":""}},[_c('source',{attrs:{"src":_vm.urlVideo,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }